export const DIARY_AX_TASK_LIST_REQUEST = 'DIARY_AX_TASK_LIST_REQUEST'
export const DIARY_AX_TASK_LIST_SUCCESS = 'DIARY_AX_TASK_LIST_SUCCESS'
export const DIARY_AX_TASK_LIST_FAIL = 'DIARY_AX_TASK_LIST_FAIL'
export const DIARY_AX_TASK_LIST_RESET = 'DIARY_AX_TASK_LIST_RESET'
